export const TYPE_RESV = 1;
export const TYPE_MANUAL = 2;
export const TYPE_EXPIRED = 3;